import { render, staticRenderFns } from "./RestClosed.vue?vue&type=template&id=f088b896"
import script from "./RestClosed.vue?vue&type=script&lang=js"
export * from "./RestClosed.vue?vue&type=script&lang=js"
import style0 from "./RestClosed.vue?vue&type=style&index=0&id=f088b896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports